/*@ngInject*/
const BaseCachedSharedPromiseRepository = function ($http, $q, $cacheFactory) {

    this.getCacheName = function () {
        return '';
    };

    this.getCacheCapacity = function () {
        return 0;
    };

    this.clearCache = function () {
        let cache = $cacheFactory.get(this.getCacheName());
        if (cache) {
            cache.removeAll();
        }
    };

    this.getSharedPromiseCache = function () {
        return null;
    };

    this.get = function (cacheKey, url, config) {
        let cache = $cacheFactory.get(this.getCacheName()),
            defer;

        function onSuccess(response) {
            let processedResponseData;

            if (response) {
                processedResponseData = this.processResponseData(_.cloneDeep(response.data));

                cache.put(cacheKey, processedResponseData);

                defer.resolve(processedResponseData);
            } else {
                defer.reject();
            }
        }

        function onError(errorResponse) {
            return defer.reject(errorResponse.data);
        }

        function onFinally() {
            this.getSharedPromiseCache()[cacheKey] = null;
            delete this.getSharedPromiseCache()[cacheKey];
        }

        if (!cache) {
            cache = $cacheFactory(this.getCacheName(), {capacity: this.getCacheCapacity()});
        }

        if (_.has(this.getSharedPromiseCache(), cacheKey)) {
            return _.get(this.getSharedPromiseCache(), cacheKey);
        }

        if (!_.isNil(cache.get(cacheKey))) {
            return $q.when(cache.get(cacheKey));
        }

        defer = $q.defer();

        $http.get(url, config).then(onSuccess.bind(this), onError).finally(onFinally.bind(this));

        this.getSharedPromiseCache()[cacheKey] = defer.promise;

        return defer.promise;
    };

    this.processResponseData = function (responseData) {
        return responseData;
    };
};

angular.module('umCore')
    .service('baseCachedSharedPromiseRepository', BaseCachedSharedPromiseRepository);
